module.exports = __webpack_public_path__ + "img/guide05.5ca64590.png";